/* eslint-disable */
import { Authenticator, Link, useAuthenticator, View, Alert } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css'; // Add this for default styling
import { library } from "@fortawesome/fontawesome-svg-core";
import { signIn } from "aws-amplify/auth";
import {
  faArrowAltCircleDown,
  faArrowCircleDown,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faCheck,
  faCog,
  faCopy,
  faEllipsisV,
  faFileCsv,
  faFilter,
  faInfo,
  faKey,
  faList,
  faMailBulk,
  faPen,
  faPencilAlt,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faSearch,
  faShareAlt,
  faShareSquare,
  faSignOutAlt,
  faSort,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faSortAmountDown,
  faSortAmountDownAlt,
  faSortDown,
  faSortNumericDown,
  faSortNumericDownAlt,
  faSortUp,
  faStar,
  faTimes,
  faTrash,
  faTrashAlt,
  faUndo,
  faUser,
  faUserCheck,
  faUserMinus,
  faUserPlus,
  faUserSlash,
} from "@fortawesome/free-solid-svg-icons";
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { CustomForgotPassword } from "CustomForgotPassword";
import TermsAndConditions from "pages/terms/TermsAndConditions";
import { useEffect } from "react";
import ReactGA from "react-ga";
import { BrowserRouter, Redirect, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setGlobal } from "reactn";
import "./App.scss";
import Administration from "./pages/administration";
import HomePage from "./pages/home";
import '@aws-amplify/ui-react/styles.css';

library.add(
  faArrowLeft,
  faArrowUp,
  faArrowDown,
  faArrowCircleDown,
  faArrowAltCircleDown,
  faTrash,
  faTrashAlt,
  faPlusCircle,
  faPlusSquare,
  faUser,
  faUserCheck,
  faUserSlash,
  faUserPlus,
  faUserMinus,
  faTimes,
  faPencilAlt,
  faPlus,
  faCog,
  faSignOutAlt,
  faCheck,
  faUndo,
  faFilter,
  faSortAlphaDown,
  faSortAlphaDownAlt,
  faSortAmountDown,
  faSortAmountDownAlt,
  faSortNumericDown,
  faSortNumericDownAlt,
  faSort,
  faSortUp,
  faSortDown,
  faFileCsv,
  faSearch,
  faMailBulk,
  faList,
  faEllipsisV,
  faStar,
  faShareSquare,
  faShareAlt,
  faCopy,
  faKey,
  faInfo,
  faPen
);

setGlobal({
  isAdmin: false,
  isPublic: false,
  isUser: false,
  auth: null,
  termsAccepted: null,
});

const Router = () => {
  return (
    <BrowserRouter>
      <div>
        <Route exact path="/">
          <Redirect to="/v" />
        </Route>

        <Route path="/v" component={withTracker(HomePage)} />
        <Route path="/administration" component={withTracker(Administration)} />
        <Route path="/terms" component={withTracker(TermsAndConditions)} />
      </div>
    </BrowserRouter>
  );
};

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (page) => {
    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.pageview(page);
  };

  return (props) => {
    useEffect(
      () => trackPage(props.location.pathname),
      [props.location.pathname]
    );

    return <WrappedComponent {...props} />;
  };
};

const components = {
  SignIn: {
    Header() {
      return (
        <div className="text-center mb-4">
          <div className="mb-4 login-logo"></div>
          <h1 className="h1 mb-3">DPAplay</h1>
          <h2 className="h2 mb-3">Print & Apply video library</h2>
        </div>
      );
    },
    Footer() {
      const { toForgotPassword } = useAuthenticator();

      return (
        <>
          <Alert variation='info' isDismissible={true}>As part of the migration to a new system, your password needs to be reset. Click "Reset Password" or try logging in with your email. </Alert>
          <View textAlign="center">
            <span style={{ color: 'gray' }}>
              Forgot your password?{' '}
              <Link
                color={'#eee'}
                textDecoration={'underline'}
                fontWeight="normal"
                onClick={toForgotPassword}
                size="small"
                variation="link"
              >
                Reset Password
              </Link>
            </span>
          </View>
          <p className="text-light text-center">
            <br />No account? Contact <a href="mailto:marketing@dominopa.com">marketing@dominopa.com</a>
          </p>
        </>
      );
    }
  },
  ForceNewPassword: {
    Header() {
      return (
        <header className="text-center mb-4">
          <div className="mb-4 login-logo"></div>
          <h1 className="h1 mb-3">Change Password</h1>
        </header>
      );
    },
  }
};

const formFields = {
  signIn: {
    username: {
      placeholder: 'Email address',
      isRequired: true,
      labelHidden: true
    },
    password: {
      placeholder: 'Password',
      isRequired: true,
      labelHidden: true,
    }
  },
  forceNewPassword: {
    password: {
      placeholder: 'Enter your Password',
      labelHidden: true,
      isRequired: true,
    },
    confirm_password: {
      placeholder: 'Confirm your Password',
      labelHidden: true,
      isRequired: true,
    }
  },
};

function App() {
  const { route, authStatus } = useAuthenticator(context => [context.route, context.authStatus]);
  const { user } = useAuthenticator(context => [context.user]);
  const { toForgotPassword } = useAuthenticator();
  const services = {
    async handleSignIn({ username, password }) {
      try {
        const sessionResponse = await signIn({
          username,
          password,
          options: {
            authFlowType: "USER_PASSWORD_AUTH",
          },
        });
        if (sessionResponse.nextStep.signInStep === 'RESET_PASSWORD') {
          toForgotPassword()
        }

        return sessionResponse
      } catch (error) {
        console.log('error signing in', error.message);
        throw error;
      }
    },
  }
  const getAuthComponent = () => {
    switch (route) {
      case 'forgotPassword':
        return <CustomForgotPassword />;
      default:
        if ((authStatus === 'authenticated') && user) {
          const checkAuth = async () => {
            try {
              const { tokens } = await fetchAuthSession();
              let payload = tokens.idToken.payload;
              setGlobal({
                isAdmin: payload?.["cognito:groups"]?.includes("Admin") || false,
                isPublic: payload?.["cognito:groups"]?.includes("Public") || false,
                isUser: payload?.["cognito:groups"]?.includes("User") || false,
                auth: payload,
              });
              const terms = payload["custom:terms_accepted"]
              if (!terms) {
                const { tokens } = await fetchAuthSession({ forceRefresh: true });
                payload = tokens.idToken.payload;
              }
              localStorage.setItem(
                "terms-accepted",
                payload["custom:terms_accepted"] === "true"
              );
            } catch (e) {
              console.error("Auth session error:", e);
              setGlobal({
                isAdmin: false,
                isPublic: false,
                isUser: false,
                auth: null,
              });
            }
          };

          checkAuth()
          return (
            <>
              <ToastContainer />
              <Router />
            </>
          )
        } else {
          return (
            <Authenticator services={services} hideSignUp={true} formFields={formFields} components={components} />
          )
        }
    }
  };

  return getAuthComponent();
}

function AppWithAuth() {
  useEffect(() => {
    const listener = async (data) => {
      switch (data.payload.event) {
        case "signUp":
        case "signedOut":
          setGlobal({
            isAdmin: false,
            isPublic: false,
            isUser: false,
            auth: null,
          });
          window.location.href = '/'
          break;
        case "signIn_failure":
        case "signedIn":
        case "tokenRefresh":
          try {
            const { tokens } = await fetchAuthSession({ forceRefresh: data.payload.event === 'signedIn' ? true : false });
            const payload = tokens.idToken.payload;
            setGlobal({
              isAdmin: payload?.["cognito:groups"]?.includes("Admin") || false,
              isPublic: payload?.["cognito:groups"]?.includes("Public") || false,
              isUser: payload?.["cognito:groups"]?.includes("User") || false,
              auth: payload,
            });

            localStorage.setItem(
              "terms-accepted",
              payload["custom:terms_accepted"] === "true"
            );
          } catch (e) {
            console.error("Auth session error:", e);
            setGlobal({
              isAdmin: false,
              isPublic: false,
              isUser: false,
              auth: null,
            });
          }
          break;
      }
    };

    const hubUnsubscribe = Hub.listen("auth", listener);

    return () => {
      hubUnsubscribe();
    };
  }, []);
  return (
    <Authenticator.Provider>
      <App />
    </Authenticator.Provider>
  );
}

export default AppWithAuth;
